import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import _ from 'lodash';
import "../index.css"

import { Tooltip } from "primereact/tooltip";
import { Button } from '../../../../helpers'
import Loading from "../../../../common/Loading"
import DispatchSellerPOItemsStock from './dispatchSellerPOItemsStock'

import { raiseToast } from "../../../../services/redux/reducers/toast/toast";
import { getMaterialMasterDetailsTooltip, round } from '../../../../utils'


const ConvertToStock = (props) => {
    const [dispatchSellerPOItems, setDispatchSellerPOItems] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    const [isAllDispatchItemsConvertedToStock, setIsAllDispatchItemsConvertedToStock] = useState(false)

    const dispatch = useDispatch()

    useEffect(() => {
        setDispatchSellerPOItems(props.selectedDispatchSellerPOItems)
    }, [])

    useEffect(() => {
        let allDispatchItemsConvertedToStock = Object.keys(dispatchSellerPOItems)?.every(key => {
            let sellerPOItems = dispatchSellerPOItems[key]
            let isTotalQtyConverted = sellerPOItems.every((sellerPOItem) => {
                return sellerPOItem?.availableDispatchQuantity === 0
            })
            return isTotalQtyConverted
        })
        setIsAllDispatchItemsConvertedToStock(allDispatchItemsConvertedToStock)
    }, [dispatchSellerPOItems])

    const handleSubmit = async () => {
        let relatedSellerPOItems = []
        Object.keys(dispatchSellerPOItems)?.map(key => {
            let sellerPOItems = dispatchSellerPOItems[key]
            relatedSellerPOItems.push(...sellerPOItems)
        })
        let isQtyEntered = relatedSellerPOItems?.some(eachSellerPOItem => eachSellerPOItem?.convertToStockQty > 0)
        let updatedSellerPOItems = relatedSellerPOItems?.filter(eachSellerPOItem => eachSellerPOItem?.convertToStockQty > 0)

        let sellerPOMaterialIdMappedArr = []
        updatedSellerPOItems.forEach(eachSellerPOItem => {
            const relatedSellerPOMaterialId = sellerPOMaterialIdMappedArr.find(eachSellerPOMaterialId => eachSellerPOMaterialId.sellerPODocNo === eachSellerPOItem.docNo
                && eachSellerPOMaterialId.materialId === eachSellerPOItem.materialId
            )

            if(!relatedSellerPOMaterialId){
                const newSellerPOMaterialIdMappedObj = {
                    sellerPODocNo: eachSellerPOItem.docNo,
                    materialId: eachSellerPOItem.materialId,
                    availableDispatchQuantity: parseFloat(eachSellerPOItem.availableDispatchQuantity),
                    convertToStockQty: eachSellerPOItem.convertToStockQty
                }
                sellerPOMaterialIdMappedArr = [...sellerPOMaterialIdMappedArr, newSellerPOMaterialIdMappedObj]
            }
            else{
                sellerPOMaterialIdMappedArr = sellerPOMaterialIdMappedArr.map(eachSelPOMap => {
                    if(eachSelPOMap.sellerPODocNo === eachSellerPOItem.docNo && eachSelPOMap.materialId === eachSellerPOItem.materialId){
                        return {...eachSelPOMap, convertToStockQty: parseFloat(relatedSellerPOMaterialId.convertToStockQty) + parseFloat(eachSelPOMap.convertToStockQty)}
                    }
                })
            }
        })

        const invalidQtyMaterial = sellerPOMaterialIdMappedArr.find(eachSellerPOMaterialId => {
            if(eachSellerPOMaterialId.convertToStockQty > eachSellerPOMaterialId.availableDispatchQuantity){
                return true
            }
            return false
        })

        if(invalidQtyMaterial){
            return dispatch(raiseToast({ severity: 'warn', detail: `Total accepted qty for material ${invalidQtyMaterial.materialId}(${invalidQtyMaterial.sellerPODocNo}) is ${invalidQtyMaterial.availableDispatchQuantity} Only, tried to convert ${invalidQtyMaterial.convertToStockQty} qty!`, life: 3000 }))
        }
        
        if (isQtyEntered){
            // const sellerPOIds = _.uniqBy(updatedSellerPOItems.map(eachSellerPOItem => eachSellerPOItem.sellerPOId))
            // const useFromStockSellerPO = props.selectedDispatchSellerPOs.find(eachSelPO => sellerPOIds.includes(eachSelPO.sellerPOId) && eachSelPO.companyId === 1)

            // if(useFromStockSellerPO){
            //     return dispatch(raiseToast({severity:'error', detail: `Tried to convert materials from UseFromStock Seller PO(${useFromStockSellerPO.docNo}). Please reverse the GRN to get it back to stock`, life: 3000}))
            // }
            props.handleSubmitConvertToStock(updatedSellerPOItems)
        }else{
            dispatch(raiseToast({severity:'error', detail: 'Please Enter the Quantities', life: 3000}))
        }
    }

    const handleDispatchQtyChange = (event, key, sellerPOItemId) => {
        dispatchSellerPOItems[key].map(sellerPOItem => {
            if (sellerPOItem.sellerPOItemId === sellerPOItemId) {
                let availableQty = round(sellerPOItem.availableDispatchQuantity)
                if (event.target.value > availableQty) {
                    dispatch(raiseToast({ severity: 'warn', detail: `Available Qty : ${availableQty} Only`, life: 3000 }))
                } else {
                    sellerPOItem.convertToStockQty = event.target.value
                }
            }
        })

        setDispatchSellerPOItems({ ...dispatchSellerPOItems })
    }

    return (
        <>
            {
                Object.keys(dispatchSellerPOItems)?.map(key => {
                    let buyerReqItemId = key
                    let sellerPOItems = dispatchSellerPOItems[key]
                    let materialId = sellerPOItems[0].materialId
                    let buyerProductName =  sellerPOItems[0]?.productName
                    let buyerProductSpecifications = sellerPOItems[0]?.productSpecification
                    return (
                        <div key={buyerReqItemId} className="p-card col-12 mb-2 xl:col-12 m-0" style={{ padding: 0 }} >
                            <div style={{ display: "flex", justifyContent: "space-between", flex: 1, }}>
                                <div style={{ marginLeft: "10px", alignItems: "center" }}>
                                    <p className="mb-0 mt-2"><span style={{ fontWeight: 700 }}>
                                        <span className={`custom-tool-tip-${materialId}`}>{materialId}</span>
                                        <Tooltip target={`.custom-tool-tip-${materialId}`} position="top" autoHide={true}>
                                            {getMaterialMasterDetailsTooltip({...sellerPOItems[0], brandName: sellerPOItems[0]?.brandName, productName: sellerPOItems[0]?.productName, productSpecification: sellerPOItems[0]?.productSpecification , variantName: sellerPOItems[0]?.variantName, renderHTML : true})}
                                        </Tooltip>
                                        </span> | {buyerProductName} | {buyerProductSpecifications}</p>
                                </div>
                            </div>
                            <div className="mt-1" style={{ paddingLeft: 15, paddingRight: 15 }}>
                                <div>
                                    <div style={{ height: 6 }} ></div>
                                    {
                                        sellerPOItems.map(( sellerPOItem, index) => {
                                            let displayLabel = false
                                            if (index === 0) {
                                                displayLabel = true
                                            }
                                            return (
                                                < DispatchSellerPOItemsStock
                                                    buyerReqItemId={buyerReqItemId}
                                                    sellerPOItem={sellerPOItem}
                                                    displayLabel={displayLabel}
                                                    isQtyCannotBeChanged={true}
                                                    handleDispatchQtyChange={handleDispatchQtyChange}
                                                    isAllDispatchItemsConvertedToStock={isAllDispatchItemsConvertedToStock}
                                                />
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                    )
                })
            }
            <Loading visible={isLoading}/>
            <Button className="small-btn mb-1" style={{ float: "right" }} label='Convert To Stock' onClick={handleSubmit} disabled={isAllDispatchItemsConvertedToStock}/>
        </>
    )
}

export default ConvertToStock;